import { render, staticRenderFns } from "./recharge_bonus_list.vue?vue&type=template&id=8bfbde98"
import script from "./recharge_bonus_list.vue?vue&type=script&lang=js"
export * from "./recharge_bonus_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports